<template>
  <v-card class="import-action-input">
    <v-card-title class="justify-center">
      {{ $t('sor.import_action_input') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row>
          <v-col cols="4"
                 class="input-label">{{ $t('sor.action_input') }}
          </v-col>
          <v-col cols="8">
            <FileInput v-model="excelFile"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       :rules="requiredRules"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'ImportActionInputDialog',
  components: {FileInput},
  props: {
    volumeId: String,
    aSoRId: String,
    corrigendumId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);
    const excelFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('volume_id', props.volumeId);
      formData.append('a_sor_id', props.aSoRId);
      formData.append('corrigendum_id', props.corrigendumId);
      formData.append('excel', excelFile.value, excelFile.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: `admin/${props.corrigendumId ? 'corrigendum' : (props.volumeId ? 'volume': 'contract/a_sor')}/upload_action/`,
        params: formData,
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    return {
      requiredRules,
      excelFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.import-action-input {
  .input-label {
    text-align: right;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
